import { object } from 'common/helpers'


export const initialState = {
  items: [],
  product: {},
  tags: {},
  isFirstStep: true,
  shouldBeShared: {
    facebook: true,
    twitter: false,
  },
  shouldSendProductId: true,
}

export const setItems = (state, payload) =>
  ({ ...state, items: payload })

export const setProduct = (state, payload) =>
  ({ ...state, product: payload })

export const setTags = (state, payload) =>
  ({ ...state, tags: payload })

export const setIsFirstStep = (state, payload) =>
  ({ ...state, isFirstStep: payload })

export const setShouldBeShared = (state, payload) =>
  ({ ...state, shouldBeShared: payload })

export const setShouldSendProductId = (state, payload) =>
  ({ ...state, shouldSendProductId: payload })

export const setProductRating = (state, payload) =>
  object.update(state, 'product', (product) => ({ ...product, rating: payload }))
